import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PulseOnChangeDirective } from '../shared/pulse-on-change.directive';
import { BetSlipSummaryViewModel } from './betslip-ticket.models';

@Component({
  selector: 'app-betslip-mobile-widget',
  standalone: true,
  imports: [CommonModule, TranslateModule, PulseOnChangeDirective],
  templateUrl: './betslip-mobile-widget.component.html',
  styleUrl: './betslip-mobile-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BetslipMobileWidgetComponent {
  readonly summary = input.required<BetSlipSummaryViewModel>();
  readonly maxWinPulseKey = input.required<number>();

  readonly open = output<void>();
}
